<template>
    <div
        class="absolute right-3 top-3 flex h-[38px] w-[38px] cursor-pointer items-center justify-center md:h-[30px] md:w-[30px]"
    >
        <v-lightbox>
            <template v-slot:trigger>
                <div
                    class="flex h-[38px] w-[38px] items-center justify-center rounded-full bg-white md:h-[30px] md:w-[30px]"
                >
                    <v-icon icon="trash" size="5" class="md:hidden"></v-icon>
                    <v-icon
                        icon="trash"
                        size="4"
                        class="hidden lg:flex"
                    ></v-icon>
                </div>
            </template>
            <template v-slot:head>
                <v-icon icon="trash" size="4" class="mr-2.5"></v-icon>
                Izbrišite oglas
            </template>
            <template v-slot:content>
                <template v-if="!listingDeleted">
                    <div class="mb-5 flex flex-col items-center">
                        <div
                            class="mb-11 mt-5 flex items-center text-icon-text-medium text-black-78"
                        >
                            Ali ste prepričani, da želite za vedno izbrisati
                            oglas?
                        </div>
                        <figure
                            class="mx-auto mb-7 flex w-full max-w-[440px] items-center gap-4"
                        >
                            <div
                                class="flex min-h-[40px] min-w-[40px] items-center justify-center rounded-full bg-salmon"
                            >
                                <v-icon
                                    icon="trash"
                                    size="5"
                                    class="text-white"
                                ></v-icon>
                            </div>
                            <div class="text-body-regular">
                                Oglas ne bo več viden ostalim iskalcem
                                nepremičnin.
                            </div>
                        </figure>
                        <figure
                            class="mx-auto mb-7 flex w-full max-w-[440px] items-center gap-4"
                        >
                            <div
                                class="flex min-h-[40px] min-w-[40px] items-center justify-center rounded-full bg-salmon"
                            >
                                <v-icon
                                    icon="trash"
                                    size="5"
                                    class="text-white"
                                ></v-icon>
                            </div>
                            <div class="text-body-regular">
                                Z izbrisom oglasa nepremičnine se izbrišejo tudi
                                vsi podatki o nepremičnini.
                            </div>
                        </figure>
                        <figure
                            class="mx-auto flex w-full max-w-[440px] items-center gap-4"
                        >
                            <div
                                class="flex min-h-[40px] min-w-[40px] items-center justify-center rounded-full bg-salmon"
                            >
                                <v-icon
                                    icon="trash"
                                    size="5"
                                    class="text-white"
                                ></v-icon>
                            </div>
                            <div class="text-body-regular">
                                Če bi želeli oglas obdržati, vendar ne želite,
                                da je viden iskalcem, ga lahko
                                <a href="" class="font-medium underline"
                                    >deaktivirate tukaj</a
                                >.
                            </div>
                        </figure>
                    </div>
                </template>
                <template v-else>
                    <div
                        class="flex min-h-[240px] items-center justify-center gap-[10px]"
                    >
                        <v-icon icon="trash" class="text-green"></v-icon>
                        <div class="text-icon-text-medium text-green">
                            Uspešno ste izbisali oglas
                        </div>
                    </div>
                </template>
            </template>
            <template v-slot:foot>
                <a
                    v-if="!listingDeleted"
                    @click="listingDeleted = true"
                    class="button button--form button--salmon"
                >
                    <v-icon icon="trash"></v-icon>
                    <label>Izbrišite oglas</label>
                </a>
                <a v-else class="button button--form">
                    <label>Zapri</label>
                    <v-icon icon="close"></v-icon>
                </a>
            </template>
        </v-lightbox>
    </div>
</template>

<script>
export default {
    props: {
        listingDeleted: {
            type: Boolean,
            default: false,
        },
    },
};
</script>
